/**
 * Toast Notification Component
 *
 * Displays notifications from useUiStore
 */

import { useEffect } from "react";
import { useUiStore } from "@/lib/store";

export function ToastContainer() {
  const notifications = useUiStore((s) => s.notifications);
  const removeNotification = useUiStore((s) => s.removeNotification);

  return (
    <div className="fixed bottom-4 right-4 space-y-2 z-50">
      {notifications.map((notif) => (
        <Toast
          key={notif.id}
          notification={notif}
          onClose={() => removeNotification(notif.id)}
        />
      ))}
    </div>
  );
}

interface ToastProps {
  notification: {
    id: string;
    type: "success" | "error" | "info" | "warning";
    message: string;
    duration?: number;
  };
  onClose: () => void;
}

function Toast({ notification, onClose }: ToastProps) {
  useEffect(() => {
    if (!notification.duration) return;
    const timer = setTimeout(onClose, notification.duration);
    return () => clearTimeout(timer);
  }, [notification.duration, onClose]);

  const bgColor = {
    success: "bg-green-500",
    error: "bg-red-500",
    info: "bg-blue-500",
    warning: "bg-yellow-500",
  }[notification.type];

  return (
    <div className={`${bgColor} text-white px-4 py-3 rounded-lg shadow-lg flex items-center justify-between`}>
      <span>{notification.message}</span>
      <button
        onClick={onClose}
        className="ml-4 font-bold hover:opacity-75"
      >
        ✕
      </button>
    </div>
  );
}
